import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import slide1 from './img/slide1.png';
import slide2 from './img/slide2.png';
import slide3 from './img/slide3.png';
import slide4 from './img/slide4.png';
import slide5 from './img/slide5.png';
import slide6 from './img/slide6.png';
// import slide7 from './img/slide7.png';
// import slide8 from './img/slide8.png';
// import slide9 from './img/slide9.png';
import history from '../../history';

class LandingContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      image: [slide1, slide2, slide3, slide4, slide5, slide6],
      active: 0,
    };
  }
  componentDidMount() {
    let i = 0;
    const intervalId = setInterval(() => {
      i++;
      if (i > (this.state.image.length - 1)) {
        i = 0;
      }
      this.setState({
        active: i,
      });
    }, 4000);
  }

  goToScheduleDemo = () => {
    history.push('/demo');
  }
  render() {
    const {
      styles: s,
    } = this.props;

    const slideImage = this.state.image[this.state.active];

    return (
      <div id="top">
        <section className={s.agencyBannerArea}>
        { /* <div className={s.bubble}>
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>  */}
          <div className={s.agencyBanner}>
            <div className={s.devider}>
              <svg
                className={cx(s.uncodeRowDivider, s.uncodeRowDividerCurve)}
                x="0px"
                y="0px"
                width="240px"
                height="24px"
                viewBox="0 0 240 24"
                enableBackground="new 0 0 240 24"
                xmlSpace="preserve"
                preserveAspectRatio="none"
              >
                <path
                  fill="#ffffff"
                  d="M0,24l0.01-0.24V0H240v24c0,0-48.115-23.471-120.039-23.48C48.018,0.52,0,24,0,24L0,24z"
                />
              </svg>
            </div>
            <div className={s.container}>
              <div className={s.banerContent}>
                {/* <h6>End-to-end learning technology platform</h6> */}
                <h2>Drive skills management <br /> and employee learning using AI</h2>

              </div>
            </div>
          </div>
          <div className={s.bannerImg}>
            <img src={slideImage} alt="" />
          </div>
        </section>
      </div>
    );
  }
}

export default LandingContainer;



// WEBPACK FOOTER //
// ./src/routes/home/LandingContainer.js